import AppConstants from '../config/app.constants';

let UsersService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/users`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/users/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/users/${id}`, { params: { branchId } })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/users/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/users/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getLatestLogEntry = (id) => {
        return $http
            .get(AppConstants.api + `/users/latest-log-entry/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let updateUserKeys = (userData) => {
        return $http
            .post(AppConstants.api + `/users/update-user-key`, { userData })
            .then((res) => {
                return res.data
            })
    }

    let updateUserBranch = (id, data) => {
        return $http
            .post(AppConstants.api + `/users/update-user-branch/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let checkSupervisor = (id) => {
        return $http
            .get(AppConstants.api + `/users/check-supervisor/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getUserFieldData = (id) => {
        return $http
            .get(AppConstants.api + `/users/get-user-details/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let userList = (branch) => {
        return $http
            .get(AppConstants.api + `/users/user-list`, {
                params: { branch }
            })
            .then((res) => {
                return res.data
            })
    };

    let userPermissions = (userList) => {
        return $http
            .post(AppConstants.api + `/users/user-permissions`, {userList})
            .then((res) => {
                return res.data
            })
    };

    let userPermissionReport = (userList) => {
        return $http
            .post(AppConstants.api + `/users/user-permission-report`, { userList })
            .then((res) => {
                return res.data
            })
    };

    let changeWebPassword = (loggedInUser, loggedInUsersBranch,  userId, password) => {
        return $http
            .post(AppConstants.api + `/user/change-web-password`, {loggedInUser, loggedInUsersBranch, userId, password })
            .then((res) => {
                return res.data
            })
    };

    let send2FACode = (emailOrUserId) => {
        return $http
            .post(AppConstants.api + `/user/send-2FA-code`, { emailOrUserId })
            .then((res) => {
                return res.data
            })
    };

    let verify2FACode = (emailOrUserId, code) => {
        return $http
            .post(AppConstants.api + `/user/verify-2FA-code`, { emailOrUserId, code })
            .then((res) => {
                return res.data
            })
    };

    let validateUserPermissions = (firstName, lastName) => {
        return $http
            .get(AppConstants.api + `/users/validate-user-permissions`, {
                params: { firstName, lastName }
            })
            .then((res) => {
                return res.data
            })
    };

    let updateCustomerUserPermissions = () => {
        return $http
            .post(AppConstants.api + `/users/update-customer-user-permissions`)
            .then((res) => {
                return res.data
            })
    }

    let bulkUpdateCustomerUsers = (data) => {
        return $http
            .post(AppConstants.api + `/users/bulk-update-customer-users`, data)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        bulkUpdateCustomerUsers,
        update,
        get,
        getLatestLogEntry,
        updateUserKeys,
        updateUserBranch,
        checkSupervisor,
        getUserFieldData,
        userList,
        userPermissions,
        userPermissionReport,
        changeWebPassword,
        send2FACode,
        verify2FACode,
        validateUserPermissions,
        updateCustomerUserPermissions
    };
};

UsersService.$inject = ['$http', '$q'];

export default UsersService;


// WEBPACK FOOTER //
// ./client/app/services/users.service.js